import { Primitive, StorageClient, StorageResult } from '../state/types';

interface StorageApi {
  getItem(itemName: string): string | null;
  removeItem(itemName: string): void;
  setItem(itemName: string, value: string): void;
}

export const createStorageClient = ({ keyPrefix, storageApi }: { keyPrefix: string; storageApi: StorageApi }): StorageClient => ({
  createController: <ValueType extends Primitive | Record<string, Primitive> | Primitive[]>(itemName: string) => ({
    get: () => {
      const value = storageApi.getItem(`${keyPrefix}${itemName}`);

      if (value === null) {
        return { status: 'error', type: 'missingValue' };
      }

      try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const parsedValue = JSON.parse(value);

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        return { status: 'success', value: parsedValue } as StorageResult<ValueType>;
      } catch (error) {
        return { status: 'error', type: 'malformedValue' };
      }
    },
    set: (value) => {
      storageApi.setItem(`${keyPrefix}${itemName}`, JSON.stringify(value));

      return { status: 'success' };
    },
    remove: () => {
      storageApi.removeItem(`${keyPrefix}${itemName}`);

      return { status: 'success' };
    },
  }),
});
